//@ts-ignore
import AWN from "awesome-notifications";
import Choices from "choices.js";
import * as bootstrap from "bootstrap";

export const ready = function(fn : any) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

export const on = function(event : string, selector : string, callback : Function, dynamic : boolean = false) {
    if(dynamic) {
        document.addEventListener(event, function (e) {
            if(e.target) {
                let target = (e.target as HTMLElement).closest(selector) as Element;
                if(target) {
                    callback(target);
                }
            }
        });
    } else {
        document.querySelectorAll(selector).forEach((el) => el.addEventListener(event, (e) => callback(e.target)));
    }
}

export const on_keyup = function(keyCode : number, selector : string, callback : Function) {
    document.addEventListener('keyup', function (e) {
        if(e.target && e.key === 'Enter') {
            let target = (e.target as HTMLElement).closest(selector) as Element;
            if(target) {
                callback(target);
            }
        }
    });
}

export const trigger = function(selector : string, event : string) {
    document.querySelectorAll(selector).forEach((el) => el.dispatchEvent(new Event(event)));
}

export const get = function(url : string, data : any, callback : Function) : void {
    const params = new URLSearchParams(data);

    const baseUrl = window.location.origin + window.location.pathname;
    const fullUrl = new URL(url, baseUrl);

    if (params.toString()) {
        fullUrl.search = fullUrl.search ? fullUrl.search + '&' + params.toString() : params.toString();
    }

    fetch(fullUrl, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
    .then(response => response.json())
    .then(data => callback(data))
    .catch(error => console.error('Error fetching data:', error));
}

export const post = function(url : string, data : any, callback : Function) : void {
    const baseUrl = window.location.origin + window.location.pathname;
    const fullUrl = new URL(url, baseUrl);

    fetch(fullUrl,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: new URLSearchParams(data)
    })
    .then(response => response.json())
    .then(data => callback(data))
    .catch(error => {
        console.error('Error fetching data:', error);
        callback({ ok: false, error: 'network' });
    });
}

export const val = function (selector : string, value : any | undefined = undefined) {
    if(typeof value === 'undefined') {
        if(document.querySelector(selector)?.nodeName === 'SELECT') {
            return (document.querySelector(selector) as HTMLSelectElement).value;
        }
        return (document.querySelector(selector) as HTMLInputElement)?.value ?? null;
    } else {
        document.querySelectorAll(selector).forEach((el) => el.setAttribute('value',value !== null ? value : ''));
    }
}

export const parent = function(el : HTMLElement, selector : string) : HTMLElement | null {
    // @ts-ignore
    while((el = el.parentNode) && el !== document) {
        if (!selector || el.matches(selector)) return el;
    }
    return null;
}

export const number_format = function(number : number, decimals : number = 2) {
    let formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
    return formatter.format(number);
}

export const notifier = new AWN({
    position: 'top-right',
    durations: {
        global: 1000
    }
});

export const init_choices = function() {
    window.choices = [];
    let elements = document.querySelectorAll('.js-choices:not(.choices__input)');
    elements.forEach((elem) => {
        let options = {
            itemSelectText: ''
        };
        if(elem.classList.contains('form-select-sm')) {
            //@ts-ignore
            options.classNames = {
                containerOuter: ['choices', 'choices-sm']
            };
        }
        window.choices.push(new Choices(elem, options));
    });
}

//@ts-ignore
function get_choices_instance(element : HTMLSelectElement) : Choices | undefined {
    //@ts-ignore
    let instance : Choices | undefined;
    //@ts-ignore
    window.choices.forEach((choice : Choices) => {
        if(choice.passedElement.element === element) {
            instance = choice;
        }
    });
    return instance;
}

export const select_choices = function(element : HTMLSelectElement, value : string | string[]) {
    let values : string[] = [];
    if(typeof value === 'string') {
        values.push(value);
    } else {
        value.forEach((val) => {
            values.push(val.toString());
        });
    }
    let instance = get_choices_instance(element);
    if(instance) {
        instance.setChoiceByValue(values);
    }
}

export const reset_choices = function(element : HTMLSelectElement) {
    let instance = get_choices_instance(element);
    if(instance) {
        instance.removeActiveItems(0);
    }
}


/* SLIDE UP */
export const slideUp = (target : HTMLElement, duration= 500, callback : Function | undefined = undefined) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = "0";
    target.style.paddingTop = "0";
    target.style.paddingBottom = "0";
    target.style.marginTop = "0";
    target.style.marginBottom = "0";
    window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        if(typeof callback !== "undefined") {
            callback();
        }
    }, duration);
}

/* SLIDE DOWN */
export const slideDown = (target : HTMLElement, duration= 500, callback : Function | undefined = undefined) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = "0";
    target.style.paddingTop = "0";
    target.style.paddingBottom = "0";
    target.style.marginTop = "0";
    target.style.marginBottom = "0";
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout( () => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        if(typeof callback !== "undefined") {
            callback();
        }
    }, duration);
}

/* TOOGLE */
export const slideToggle = (target : HTMLElement, duration = 500, callback : Function | undefined = undefined) => {
    if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration, callback);
    } else {
        return slideUp(target, duration, callback);
    }
}

export function set_time() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let full = year.toString() + '-' + month.toString().padStart(2,'0') + '-' + day.toString().padStart(2,'0');
    let hours = date.getHours().toString().padStart(2,'0');
    let minutes = date.getMinutes().toString().padStart(2,'0');
    let input_date = document.querySelector('[name="date"]') as HTMLInputElement;
    let input_hours = document.querySelector('[name="hours"]') as HTMLInputElement;
    let input_minutes = document.querySelector('[name="minutes"]') as HTMLInputElement;
    if(!input_date.matches(':focus') && !input_hours.matches(':focus') && !input_minutes.matches(':focus')) {
        input_date.value = full;
        input_hours.value = hours;
        input_minutes.value = minutes;
    }
}

export function init_tooltips() {
    [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]')).map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });
}

export function color(number : number, color : string | null = null, format : boolean | null = null, decimals : number = 0, plus : boolean = true) {
    let string = '';
    if(color !== null) {
        string += `<span style="color: ` + color + `">`;
    }
    if(plus) {
        string += number >= 0 ? '+' : '';
    }
    string += (format ? number_format(number,decimals) : number);
    if(color !== null) {
        string += `</span>`;
    }
    return string;
}
